import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import PropTypes from "prop-types";
import { availableValuesCodeNameObject } from "@jutro/prop-types";
import { TypeaheadMultiSelectField } from "../../TypeaheadMultiSelectField/TypeaheadMultiSelectField";
export var timeZoneFieldPropTypes = _objectSpread(_objectSpread({}, TypeaheadMultiSelectField.propTypes), {}, {
  availableValues: PropTypes.arrayOf(PropTypes.shape(availableValuesCodeNameObject).isRequired)
});
export var TimeZoneField = function (props) {
  return React.createElement(TypeaheadMultiSelectField, _extends({}, props, {
    singleSelect: !0
  }));
};
TimeZoneField.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "TimeZoneField"
}, TimeZoneField.__docgenInfo = {
  componentName: "TimeZoneField",
  packageName: "@jutro/components",
  description: "",
  displayName: "TimeZoneField",
  methods: [],
  actualName: "TimeZoneField"
};